export enum PaperKind {
    A4 = 0
}
